import { render, staticRenderFns } from "./AnalyticsSendSidebar.vue?vue&type=template&id=ed24ad6e&"
import script from "./AnalyticsSendSidebar.vue?vue&type=script&lang=ts&"
export * from "./AnalyticsSendSidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports